import React from 'react'

import ModalBody from 'app/components/Modal/ModalBody'
import Button from 'app/components/ButtonDefault'
import TimePreferencesForm from 'app/domains/common/TimePreferencesForm'
import CalendarAccepted from 'app/components/SVGS/CalendarAccepted'

import './styles.scss'

const bc = 'on-boarding-notification-settings-modal'

export const Footer = ({ t, invalid, submitting, isShowFooter }) => {
  return (
    !isShowFooter && (
      <div className={`${bc}__footer`}>
        <Button type="submit" primary submitting={submitting} disabled={invalid}>
          {t('Confirm and continue')}
        </Button>
      </div>
    )
  )
}

const OnBoardingNotificationSettingsModal = props => (
  <ModalBody withoutCross className={`${bc}__wrapper`}>
    <div className={`${bc}__title`}>{props.t('Your notification preferences')}</div>
    <div className={`${bc}__description`}>
      <div className={`${bc}__icon-calendar`}>
        <CalendarAccepted style={{ marginRight: '-7px' }} />
      </div>
      {props.t('Let’s personalize when and how you receive your MicroAction notifications')}
    </div>
    <TimePreferencesForm {...props}>
      <Footer t={props.t} />
    </TimePreferencesForm>
  </ModalBody>
)

export default OnBoardingNotificationSettingsModal
